/**
 * Serviço para gerenciamento de tokens - Admin
 */
export const tokenService = {
  KEYS: {
    TOKEN: 'admin_token',
    USER_DATA: 'admin_user',
  },

  setToken(token) {
    localStorage.setItem(this.KEYS.TOKEN, token);
  },

  getToken() {
    const token = localStorage.getItem(this.KEYS.TOKEN);
    return token && token !== 'null' && token !== 'undefined' ? token : null;
  },

  setUserData(userData) {
    localStorage.setItem(this.KEYS.USER_DATA, JSON.stringify(userData));
  },

  getUserData() {
    const userData = localStorage.getItem(this.KEYS.USER_DATA);
    if (!userData || userData === 'null' || userData === 'undefined') {
      return null;
    }
    try {
      return JSON.parse(userData);
    } catch (error) {
      console.error('[tokenService] Error parsing user data:', error);
      return null;
    }
  },

  isAuthenticated() {
    return !!(this.getToken() && this.getUserData());
  },

  clearAll() {
    localStorage.removeItem(this.KEYS.TOKEN);
    localStorage.removeItem(this.KEYS.USER_DATA);
  },
};
